var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"91vh"}},[_c('error-content',{attrs:{"code":"500","desc":"Oh~~鬼知道服务器经历了什么~","src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }